import { render } from "./editCodeModal.vue?vue&type=template&id=ec0f266e"
import script from "./editCodeModal.vue?vue&type=script&lang=js"
export * from "./editCodeModal.vue?vue&type=script&lang=js"

import "./editCodeModal.vue?vue&type=style&index=0&id=ec0f266e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__